import { computed, unref, type MaybeRef } from 'vue';
import { useQueries } from '@tanstack/vue-query';

import { mapOffersResults } from '@/shared/lib';

import { getHotCitiesQueryOptions } from './hot-cities';

export function useAllHotCitiesQuery({
  origCityCode,
  countryCodeList,
}: {
  origCityCode: MaybeRef<string>;
  countryCodeList: MaybeRef<string[] | null>;
}) {
  const queries = useQueries({
    queries: computed(() => {
      const city = unref(origCityCode);
      const countries = unref(countryCodeList);

      if (!countries || countries.length === 0 || !city) return [];

      return countries.map(country =>
        getHotCitiesQueryOptions({
          origCityCode: city,
          destCountryCode: country,
        }),
      );
    }),
  });

  return computed(() => {
    return queries.map(query => ({
      results: query.data?.data.results.map(mapOffersResults),
      isLoading: query.isLoading,
    }));
  });
}
